import React from 'react';
import * as Styles from './PaymentStatus.styles';
import { Button } from 'gatorcomponents';
import PropTypes from 'prop-types';

const PaymentStatus = ({
  icon,
  title,
  description,
  buttonProps,
  secondButtonProps,
  pageNotLoaded,
}) => (
  <Styles.Wrapper>
    {icon && icon}
    {title && <Styles.ModalStatusTitle>{title}</Styles.ModalStatusTitle>}
    {description && <Styles.ModalStatusInfo>{description}</Styles.ModalStatusInfo>}

    {(buttonProps || secondButtonProps) && (
      <Styles.ButtonsWrapper>
        {buttonProps && <Button {...buttonProps} />}
        {secondButtonProps && <Button {...secondButtonProps} />}
      </Styles.ButtonsWrapper>
    )}

    {pageNotLoaded && (
      <Styles.PageNotLoaded>
        {pageNotLoaded}
      </Styles.PageNotLoaded>
    )}
  </Styles.Wrapper>
);

PaymentStatus.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.node,
  buttonProps: PropTypes.object,
  secondButtonProps: PropTypes.object,
  pageNotLoaded: PropTypes.node,
};

export default PaymentStatus;
